export const defaultMedicalConditionType = {
    name: '',
    displayOrder: 0,
    isActive: true,
}
